import moment from 'moment'

import {
	addMinutes,
	getDateNow,
	getFormattedDateTime,
	getTimeDifference,
	getTimeNow
} from '@/utils/helpers'

import { BUSINESS_DAYS_TO_ROWS } from '@/constants'

const TIME_TYPES = ['FIRST_DAY_STARTS', 'TRANSITION_DAY', 'SECOND_DAY_STARTS']
const DAY_TYPES = ['IS_PREVIOUS_DAY', 'IS_CURRENT_DAY', 'IS_NEXT_DAY']

export default {
	getPickUpHoursTime(venueInfo, gap = 10) {
		const { timeZone } = venueInfo

		this.venueInfo = venueInfo
		this.gap = gap
		this.pickUpHours = []
		this.pickUpTime = {}
		this.timeZone = timeZone
		this.nowDate = getDateNow(timeZone)
		this.nowTime = getTimeNow(timeZone)
		this.currentPickupAvailablePeriods = []

		this.setPreviousDayPickUpHours()
		this.setCurrentDayPickUpHours()

		return {
			pickUpHours: this.getClosestAvailableTime() || {},
			pickUpTime: this.pickUpTime,
			currentPickupAvailablePeriods: this.currentPickupAvailablePeriods
		}
	},

	// TODO: Remove from v.4.2
	// getDaysShift() {
	// 	const { weekStart } = this.venueInfo.businessDays
	//
	// 	if (!weekStart) {
	// 		return 0
	// 	} else {
	// 		return WEEK_DAYS.findIndex(day => {
	// 			return day.short.toLowerCase() === weekStart.toLowerCase()
	// 		})
	// 	}
	// },

	getIndexOfDow(date) {
		const nowDayIndex = date.day()
		let index = nowDayIndex + 1

		if (index > 7) {
			index -= 7
		} else if (index < 1) {
			index += 7
		}

		return index
	},

	getPickUpIntervalsLen(businessDayTime) {
		const { pickUpTimeInterval } = this.venueInfo.settings

		return isNaN(pickUpTimeInterval) || pickUpTimeInterval === 0
			? 0
			: Math.trunc(businessDayTime / pickUpTimeInterval)
	},

	getBusinessDayTime(startTime, endTime) {
		const isOneDay = getTimeDifference(startTime, endTime) < 0
		let businessDayTime

		if (isOneDay) {
			businessDayTime = moment
				.duration(getTimeDifference(endTime, startTime))
				.asMinutes()
		} else {
			const yesterdayDiff = moment
				.duration(getTimeDifference('24:00:00', startTime))
				.asMinutes()
			const todayDiff = moment
				.duration(getTimeDifference(endTime, '00:00:00'))
				.asMinutes()
			businessDayTime = yesterdayDiff + todayDiff
		}

		return businessDayTime
	},

	getDayAllPickUpHours(date) {
		const { pickupHours } = this.venueInfo
		const indexOfDow = this.getIndexOfDow(date)
		let dayAllPickUpHours = pickupHours.filter(hoursObj => {
			return hoursObj.dow === indexOfDow && !hoursObj.closed
		})

		if (!dayAllPickUpHours) return []

		dayAllPickUpHours = dayAllPickUpHours.sort((dayA, dayB) => {
			return dayA.position - dayB.position
		})

		return dayAllPickUpHours
	},

	getPickUpTime({ hoursObj, timeType, dayType, initTime }) {
		const { startTime, endTime } = hoursObj
		const {
			pickUpTimeInterval,
			pickUpTimeRange,
			pickupMinIntervalForFood
		} = this.venueInfo.settings
		const businessDayTime = this.getBusinessDayTime(startTime, endTime)
		const intervalsLen = this.getPickUpIntervalsLen(businessDayTime)
		const firstDayTime = []
		const secondDayTime = []
		const isTransition = timeType === TIME_TYPES[1]

		let isFirstDayStarts =
			timeType === TIME_TYPES[0] || timeType === TIME_TYPES[1]
		let newStartTime = startTime
		let prevStartTime = newStartTime
		let newEndTime = addMinutes(newStartTime, pickUpTimeRange)

		for (let i = 0; i <= intervalsLen; i++) {
			const newTimeObj = {
				startTime: newStartTime,
				endTime: newEndTime
			}

			let startTimeDiff = null
			let endTimeDiff = null

			let minStartTime = addMinutes(initTime, pickupMinIntervalForFood)

			if (i > 0) {
				minStartTime = addMinutes(minStartTime, this.gap)
			}

			startTimeDiff = getTimeDifference(minStartTime, newStartTime)
			endTimeDiff = getTimeDifference(newEndTime, endTime)

			if (dayType === DAY_TYPES[1] || dayType === DAY_TYPES[2]) {
				if (isTransition) {
					if (isFirstDayStarts) {
						if (startTimeDiff <= 0) {
							firstDayTime.push(newTimeObj)
						}
					} else if (endTimeDiff <= 0) {
						secondDayTime.push(newTimeObj)
					}
				} else {
					if (isFirstDayStarts) {
						if (startTimeDiff <= 0 && endTimeDiff <= 0) {
							firstDayTime.push(newTimeObj)
						}
					} else if (endTimeDiff <= 0) {
						secondDayTime.push(newTimeObj)
					}
				}
			} else {
				if (!isFirstDayStarts) {
					if (startTimeDiff <= 0 && endTimeDiff <= 0) {
						secondDayTime.push(newTimeObj)
					}
				}
			}

			newStartTime = addMinutes(newStartTime, pickUpTimeInterval)
			newEndTime = addMinutes(newStartTime, pickUpTimeRange)
			endTimeDiff = getTimeDifference(newEndTime, endTime)

			if (getTimeDifference(prevStartTime, newStartTime) >= 0) {
				isFirstDayStarts = false
			}
			prevStartTime = newStartTime
		}

		return { firstDayTime, secondDayTime }
	},

	getPreviousDayTimeType({ timeObj, firstStartTime, endOfBusinessDay }) {
		const { startTime, endTime } = timeObj
		const isFirstDayStarts = getTimeDifference(firstStartTime, startTime) <= 0
		const isTransition = getTimeDifference(endTime, startTime) <= 0
		let timeType = ''

		if (
			!isTransition &&
			getTimeDifference(this.nowTime, endTime) < 0 &&
			getTimeDifference(startTime, this.nowTime) <= 0
		) {
			timeType = TIME_TYPES[2]
		}

		if (isTransition && getTimeDifference(this.nowTime, endTime) <= 0) {
			timeType = TIME_TYPES[1]
		} else if (
			!isFirstDayStarts &&
			getTimeDifference(this.nowTime, endTime) <= 0
		) {
			timeType = TIME_TYPES[2]
		}
		// In case pickup slots are not available now, but will be available the next day
		if (
			getTimeDifference(this.nowTime, endTime) < 0 &&
			isFirstDayStarts &&
			getTimeDifference(startTime, endTime) < 0 &&
			getTimeDifference(endTime, endOfBusinessDay) < 0 &&
			!timeType
		) {
			timeType = TIME_TYPES[2]
		}

		return timeType
	},

	setExistingPreviousDayPickUpHours(data) {
		const { timeObj, timeType, todayDate: formattedTodayDate } = data
		const { secondDayTime } = this.getPickUpTime({
			hoursObj: timeObj,
			timeType,
			dayType: DAY_TYPES[0],
			initTime: this.nowTime
		})

		if (secondDayTime.length) {
			this.pickUpHours.push(timeObj)

			if (!this.pickUpTime[formattedTodayDate]) {
				this.pickUpTime[formattedTodayDate] = []
			}
			this.pickUpTime[formattedTodayDate] = [
				...this.pickUpTime[formattedTodayDate],
				...secondDayTime
			]
		}
	},

	setPreviousDayPickUpHours() {
		const previousBusinessDay = moment(this.nowDate).subtract(1, 'days')
		const dayAllPickUpHours = this.getDayAllPickUpHours(previousBusinessDay)

		const curTime = this.nowDate.format('HH:mm:ss')
		const { businessDays } = this.venueInfo
		// Current day of the week number
		const indexOfDow = this.getIndexOfDow(moment(this.nowDate))

		let endOfBusinessDay = businessDays[BUSINESS_DAYS_TO_ROWS[indexOfDow]]

		const isPrevDay = curTime < endOfBusinessDay

		if (!dayAllPickUpHours.length || !isPrevDay) return

		const formattedTodayDate = getFormattedDateTime(this.nowDate, this.timeZone)
		const firstStartTime = dayAllPickUpHours[0].startTime

		for (let i = 0; i < dayAllPickUpHours.length; i++) {
			const timeObj = dayAllPickUpHours[i]
			const timeType = this.getPreviousDayTimeType({
				timeObj: timeObj,
				firstStartTime,
				endOfBusinessDay
			})

			if (timeType.length) {
				this.setExistingPreviousDayPickUpHours({
					timeObj,
					timeType,
					todayDate: formattedTodayDate
				})
			}
		}
	},

	getCurrentDayTimeType({ timeObj, firstStartTime }) {
		const { startTime, endTime } = timeObj
		const isFirstDayStarts = getTimeDifference(firstStartTime, startTime) <= 0
		const isTransition = getTimeDifference(endTime, startTime) <= 0
		let timeType = ''

		const indexOfDow = this.getIndexOfDow(moment(this.nowDate))

		const endOfBusinessDay = this.venueInfo.businessDays[
			BUSINESS_DAYS_TO_ROWS[indexOfDow]
		]
		// startTime and endTime of the period is on the next calendar day, but on the current business day
		const isPeriodOnNextCalendarDay =
			endOfBusinessDay > startTime && endOfBusinessDay >= endTime
		// Period start and end time today (calendar and business), but later
		const isPeriodAvailableLater =
			this.nowTime < startTime &&
			endOfBusinessDay < startTime &&
			endOfBusinessDay < endTime

		if (
			!isTransition &&
			isFirstDayStarts &&
			getTimeDifference(this.nowTime, startTime) >= 0 &&
			getTimeDifference(this.nowTime, endTime) <= 0
		) {
			timeType = TIME_TYPES[0]
		} else if (isTransition) {
			timeType = TIME_TYPES[1]
		} else if (!isFirstDayStarts) {
			timeType = TIME_TYPES[2]
		}

		if (isPeriodAvailableLater) {
			timeType = TIME_TYPES[1]
		}
		// If period starts and ends on the next calendar day
		if (isPeriodOnNextCalendarDay) {
			timeType = TIME_TYPES[2]
		}

		return timeType
	},

	setExistingCurrentDayPickUpHours(data) {
		const {
			timeObj,
			timeType,
			todayDate: formattedTodayDate,
			tomorrowDate: formattedTomorrowDate
		} = data
		const { firstDayTime, secondDayTime } = this.getPickUpTime({
			hoursObj: timeObj,
			timeType,
			dayType: DAY_TYPES[1],
			initTime: this.nowTime
		})

		if (firstDayTime.length || secondDayTime.length) {
			this.pickUpHours.push(timeObj)
		}

		if (firstDayTime.length) {
			if (!this.pickUpTime[formattedTodayDate]) {
				this.pickUpTime[formattedTodayDate] = []
			}
			this.pickUpTime[formattedTodayDate] = [
				...this.pickUpTime[formattedTodayDate],
				...firstDayTime
			]
		}
		if (secondDayTime.length) {
			if (!this.pickUpTime[formattedTomorrowDate]) {
				this.pickUpTime[formattedTomorrowDate] = []
			}
			this.pickUpTime[formattedTomorrowDate] = [
				...this.pickUpTime[formattedTomorrowDate],
				...secondDayTime
			]
		}
	},

	setCurrentDayPickUpHours() {
		const dayAllPickUpHours = this.getDayAllPickUpHours(moment(this.nowDate))

		if (!dayAllPickUpHours.length) return

		const firstStartTime = dayAllPickUpHours[0].startTime
		const curTime = this.nowDate.format('HH:mm:ss')
		const { businessDays } = this.venueInfo
		// Current day of the week number
		const indexOfDow = this.getIndexOfDow(moment(this.nowDate))

		let endOfBusinessDay = businessDays[BUSINESS_DAYS_TO_ROWS[indexOfDow]]
		// Need compare with previous business day
		const isPrevDay = curTime < endOfBusinessDay

		if (isPrevDay) return

		const formattedTodayDate = getFormattedDateTime(this.nowDate, this.timeZone)
		const tomorrowDate = moment(this.nowDate).add(1, 'day')
		const formattedTomorrowDate = getFormattedDateTime(
			tomorrowDate,
			this.timeZone
		)

		for (let i = 0; i < dayAllPickUpHours.length; i++) {
			const timeObj = dayAllPickUpHours[i]
			const timeType = this.getCurrentDayTimeType({
				timeObj,
				firstStartTime
			})

			if (timeType.length) {
				this.setExistingCurrentDayPickUpHours({
					timeObj,
					timeType,
					todayDate: formattedTodayDate,
					tomorrowDate: formattedTomorrowDate
				})
			}
		}
	},
	// Added in the 3.6

	getDateTimeNow() {
		const nowDate = getDateNow(this.timeZone)
		const nowTime = getTimeNow(this.timeZone)

		return {
			nowDate,
			nowTime
		}
	},

	getClosestAvailableTime() {
		// Date and time according venue timezone
		const { nowDate } = this.getDateTimeNow()
		// Current time in the venue
		const curTime = nowDate.format('HH:mm:ss')
		const { businessDays } = this.venueInfo
		// Current day of the week number
		const indexOfDow = this.getIndexOfDow(moment(nowDate))

		let curDow = indexOfDow
		let endOfBusinessDay = businessDays[BUSINESS_DAYS_TO_ROWS[indexOfDow]]
		// Need compare with previous business day
		const isPrevDay = curTime < endOfBusinessDay

		if (isPrevDay) {
			// Previous day of the week number
			curDow = indexOfDow === 1 ? 7 : indexOfDow - 1
			// End of the previous business day
			endOfBusinessDay = businessDays[BUSINESS_DAYS_TO_ROWS[curDow]]
		}

		const currentPeriods = this.getCurrentPeriod(
			curTime,
			isPrevDay,
			curDow,
			endOfBusinessDay
		)

		this.currentPickupAvailablePeriods = currentPeriods

		const nextAvailableToday = this.getNextAvailableToday(
			curTime,
			isPrevDay,
			curDow,
			endOfBusinessDay
		)
		// if available on the current business day, need only last period
		if (nextAvailableToday.length || currentPeriods.length) {
			const allBusinessDayPeriods = [...currentPeriods, ...nextAvailableToday]
			const lastCurPeriod =
				allBusinessDayPeriods[allBusinessDayPeriods.length - 1]

			return [lastCurPeriod]
		}

		return this.getNextAvailablePickUpTime(isPrevDay)
	},

	getNextAvailableToday(curTime, isPrevDay, indexOfDow, endOfBusinessDay) {
		const curBusinessDayPeriods = this.getDayAllForHereHours(indexOfDow)

		return curBusinessDayPeriods.filter(period => {
			const { startTime, endTime } = period
			// 24 hours period isn't available
			if (startTime === endTime || startTime === endOfBusinessDay) return false

			// Previous business day
			if (isPrevDay) {
				// Previous business day, but today according the calendar
				if (endTime <= endOfBusinessDay) {
					return startTime < endTime && startTime > curTime
				}

				return false
			}
			// Current business day and current day according the calendar
			if (startTime > endOfBusinessDay) {
				return curTime < startTime
			}
			// Current business day but next day according the calendar
			return curTime > startTime
		})
	},

	getCurrentPeriod(curTime, isPrevDay, curDow, endOfBusinessDay) {
		let dayAllForHereHours = this.venueInfo.pickupHours.filter(hoursObj => {
			if (!(hoursObj.dow === curDow && !hoursObj.closed)) return false

			const { startTime, endTime } = hoursObj
			// Current business day
			const checkIsExist = () => {
				// 24 hours period is always available
				if (startTime === endTime) {
					return true
				}
				// Period ends today
				if (startTime < endTime) {
					return startTime <= curTime && curTime <= endTime
				}
				// Period ends on the next day
				if (startTime > endTime) {
					return curTime >= startTime
				}
			}
			// Previous business day
			const checkIsExistPrevDay = () => {
				// 24 hours period is always available
				if (startTime === endTime) {
					return true
				}
				// Period ended on the day before
				if (endTime > endOfBusinessDay) return false
				// Period started on the day before
				if (startTime >= endOfBusinessDay) {
					return curTime < endTime
				}
				// Period started today
				return startTime <= curTime && curTime <= endTime
			}

			const isPeriodExistCurTime = isPrevDay
				? checkIsExistPrevDay()
				: checkIsExist()
			return hoursObj && isPeriodExistCurTime
		})

		dayAllForHereHours = dayAllForHereHours.sort((dayA, dayB) => {
			return dayA.position - dayB.position
		})

		return dayAllForHereHours
	},

	getDayAllForHereHours(indexOfDow) {
		let dayAllForHereHours = this.venueInfo.pickupHours.filter(hoursObj => {
			return hoursObj.dow === indexOfDow && !hoursObj.closed
		})

		if (!dayAllForHereHours.length) return []

		dayAllForHereHours = dayAllForHereHours.sort((dayA, dayB) => {
			return dayA.position - dayB.position
		})

		return dayAllForHereHours
	},

	getNextAvailablePickUpTime(isPrevDay) {
		const { nowDate } = this.getDateTimeNow()
		let nextDate = isPrevDay ? moment(nowDate) : moment(nowDate).add(1, 'day')

		for (let i = 0; i < 7; i++) {
			const indexOfDow = this.getIndexOfDow(moment(nextDate))
			let nextIndex = indexOfDow + i

			if (nextIndex > 7) nextIndex = nextIndex - 7

			const dayAllPickUpHours = this.getDayAllForHereHours(nextIndex)

			if (!dayAllPickUpHours.length) continue

			const firstTime = dayAllPickUpHours[0].startTime
			const secondTime = dayAllPickUpHours[dayAllPickUpHours.length - 1].endTime
			const dow = dayAllPickUpHours[0].dow

			if (firstTime && secondTime) {
				const data = {
					startTime: firstTime,
					endTime: secondTime,
					dow
				}

				return [data]
			}
		}
	}
}
